import React from 'react'

interface Props{
    onClick: () => void,
    text:string,
    active:boolean,
}


const SpeakerViewButton = ({onClick,text,active}:Props) => {
  const getColor = ():string => {
    if (active && text.toUpperCase() == "AUTO"){
      return "green";
    }
    else if (active)
      {
        return "#3d3d3d";
      }
      else{
        return "gray"
      }
};
  return (
    <div className='SpeakerViewButton' onClick={onClick} style={{background: getColor()}}>{text}</div>
  )
}

export default SpeakerViewButton